/**
 * GH #2748 item 2: deep-link redirects from the pre-644fbedf9f Tempo paths to
 * their current /tempo homes. Kept as data so the route table in index.tsx and
 * the regression test in __tests__/legacy-tempo-redirect.test.tsx guard the same
 * object -- deleting an entry here fails the test, which a test carrying its own
 * hand-copied <Route> list could not catch.
 *
 * Typed inline (no named interface): this is a local UI route-config literal,
 * not an API contract, so it carries no generated type. `from` is a path
 * relative to the authenticated layout (no leading slash); `to` is absolute.
 */
export const LEGACY_TEMPO_REDIRECTS: ReadonlyArray<{ from: string; to: string }> = [
  { from: 'policy/member-liquidity', to: '/tempo' },
  { from: 'policy/pool-appetite', to: '/tempo/pool-appetite' },
] as const;
